import React, { useState } from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { Doughnut } from "react-chartjs-2";

const DealDashboard = ({ darkMode }) => {
  const [recentDealsFilter, setRecentDealsFilter] = useState("Last 30 Days");
  const dealsByStageData = [
    { name: "pipe", value: 800 },
    { name: "Follow", value: 630 },
    { name: "Schedule", value: 850 },
    { name: "Talk", value: 280 },
    { name: "Won", value: 900 },
    { name: "Lost", value: 490 },
  ];

  const doughnutData = {
    labels: ["Red", "Blue", "Yellow", "Green"],
    datasets: [
      {
        label: "Order",
        data: [12, 19, 7, 5],
        backgroundColor: [
          "rgba(239, 68, 68, 0.7)",
          "rgba(59, 130, 246, 0.7)",
          "rgba(253, 224, 71, 0.7)",
          "rgba(34, 197, 94, 0.7)",
        ],
        borderColor: [
          "rgba(239, 68, 68, 1)",
          "rgba(59, 130, 246, 1)",
          "rgba(253, 224, 71, 1)",
          "rgba(34, 197, 94, 1)",
        ],
        borderWidth: 2,
      },
    ],
  };

  return (
    <>
      <section className="p-6 bg-gray-50 shadow rounded-2xl mb-6 dark:bg-gray-800 transition-colors">
        <div className="max-w-8xl mx-auto space-y-8">
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="group bg-white p-5 rounded-xl shadow hover:shadow-lg transition border-l-4 border-green-500 hover:bg-green-500 ">
              <p className="text-sm font-medium text-gray-500 group-hover:text-white">
                Total Companies
              </p>
              <h2 className="text-2xl font-bold text-gray-800 group-hover:text-white">
                ₹1000
              </h2>
              <span className="flex items-center text-green-600 text-sm mt-1 group-hover:text-white">
                <ArrowUpRight className="w-4 h-4 mr-1" /> +5% this month
              </span>
            </div>

            <div className="group bg-white p-5 rounded-xl shadow hover:shadow-lg transition border-l-4 border-blue-500 hover:bg-blue-500">
              <p className="text-sm font-medium text-gray-500 group-hover:text-white">
                Active Companies
              </p>
              <h2 className="text-2xl font-bold text-gray-800 group-hover:text-white">
                ₹5000
              </h2>
              <span className="flex items-center text-red-600 text-sm mt-1 group-hover:text-white">
                <ArrowDownRight className="w-4 h-4 mr-1" /> -2% this week
              </span>
            </div>

            <div className="group bg-white p-5 rounded-xl shadow hover:shadow-lg transition border-l-4 border-purple-500 hover:bg-purple-500">
              <p className="text-sm font-medium text-gray-500 group-hover:text-white">
                Active Subscribers
              </p>
              <h2 className="text-2xl font-bold text-gray-800 group-hover:text-white">
                ₹8000
              </h2>
              <span className="flex items-center text-green-600 text-sm mt-1 group-hover:text-white">
                <ArrowUpRight className="w-4 h-4 mr-1" /> +12% this week
              </span>
            </div>

            <div className="group bg-white p-5 rounded-xl shadow hover:shadow-lg transition border-l-4 border-yellow-500 hover:bg-yellow-500">
              <p className="text-sm font-medium text-gray-500 group-hover:text-white">
                Total Earnings
              </p>
              <h2 className="text-2xl font-bold text-gray-800 group-hover:text-white">
                ₹10,000
              </h2>
              <span className="flex items-center text-green-600 text-sm mt-1 group-hover:text-white">
                <ArrowUpRight className="w-4 h-4 mr-1" /> +8% this month
              </span>
            </div>
          </div>
        </div>
      </section>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 mb-6 ">
        <div className="col-span-12 lg:col-span-3 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Created Deals
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="h-64 mt-5">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dealsByStageData}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                  />
                  <Bar
                    dataKey="value"
                    fill="#10B981"
                    radius={[4, 4, 0, 0]}
                    barSize={25}
                  />
                </BarChart>
              </ResponsiveContainer>
              <span className="flex items-center justify-center text-green-600 text-sm mt-4 group-hover:text-white">
                <ArrowUpRight className="w-4 h-4 mr-1" /> +5% this month
              </span>
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-6 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors mx-4">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Created Deals
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="h-64 mt-4">
              <ResponsiveContainer width="95%" height="100%">
                <BarChart data={dealsByStageData}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12 }}
                  />
                  <Bar
                    dataKey="value"
                    fill="#10B981"
                    radius={[4, 4, 0, 0]}
                    barSize={55}
                  />
                </BarChart>
              </ResponsiveContainer>
              <span className="flex items-center justify-center text-green-600 text-sm mt-4 group-hover:text-white">
                <ArrowUpRight className="w-4 h-4 mr-1" /> +5% this month
              </span>
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-3 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Deals
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700 mx-3"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="flex-1 flex items-center justify-center bg-white dark:bg-gray-800 rounded-lg">
              <div className="w-80 h-80 mt-4">
                <Doughnut
                  data={doughnutData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-6 ">
        {/* left side */}
        <div className="col-span-12 lg:col-span-4 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Transaction
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="flex items-start justify-between mt-2">
              <div>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  30-09-25
                </p>
              </div>

              <div className="text-right ">
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* middle */}
        <div className="col-span-12 lg:col-span-4 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Transaction
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="flex items-start justify-between mt-2">
              <div>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  30-09-25
                </p>
              </div>

              <div className="text-right ">
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* right side */}
        <div className="col-span-12 lg:col-span-4 bg-white rounded-lg shadow dark:bg-gray-800 transition-colors">
          <div className="bg-white rounded-lg p-3 dark:bg-gray-800 transition-colors">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                Recently Transaction
              </h2>
              <select
                className="border rounded px-3 py-1 text-gray-600 dark:text-gray-200 dark:bg-gray-700"
                value={recentDealsFilter}
                onChange={(e) => setRecentDealsFilter(e.target.value)}
              >
                <option>Last 7 Days</option>
                <option>Last 15 Days</option>
                <option>Last 30 Days</option>
                <option>Last 60 Days</option>
              </select>
            </div>
            <hr></hr>
            <div className="flex items-start justify-between mt-2">
              <div>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-3">
                  30-09-25
                </p>
                <p className="text-md font-bold text-gray-700 group-hover:text-white">
                  Packky
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  30-09-25
                </p>
              </div>

              <div className="text-right ">
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
                <p className="text-lg font-bold text-gray-500 group-hover:text-white">
                  ₹1000
                </p>
                <p className="text-sm font-medium text-gray-500 group-hover:text-white mb-2">
                  Basic (Monthly)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DealDashboard;
